function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgWait = function SvgWait(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAE9E8"
    },
    d: "M256,26.991c-141.385,0-256,97.119-256,216.921c0,57.832,26.714,110.374,70.249,149.26 c6.123,5.47,8.56,14.118,8.56,22.323v55.862c0,4.52,2.082,8.739,5.547,11.239c0.107,0.04,5.555,4.378,12.388,1.325 c65.693-29.357,73.086-35.264,88.171-31.574C348.321,492.317,512,388.34,512,243.912C512,124.11,397.385,26.991,256,26.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M380.358,430.049C216.072,470.236,51.513,365.698,51.513,220.494 c0-73.162,42.521-137.904,107.76-177.467C65.845,75.361,0,153.114,0,243.912c0,57.832,26.714,110.374,70.249,149.26 c6.123,5.47,8.56,14.119,8.56,22.323v55.862c0,9.904,9.512,16.328,17.935,12.564c65.693-29.357,73.086-35.264,88.171-31.574 c72.885,17.829,145.824,7.018,204.268-23.246C386.191,428.941,383.433,429.297,380.358,430.049z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#656566"
    },
    cx: 151.476,
    cy: 255.279,
    r: 23.866
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#656566"
    },
    cx: 256,
    cy: 255.279,
    r: 23.866
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#656566"
    },
    cx: 360.524,
    cy: 255.279,
    r: 23.866
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545456"
    },
    d: "M151.472,255.279c-4.416-7.649-4.111-16.723,0.002-23.863c-4.057-0.004-8.169,1.02-11.934,3.194 c-11.414,6.59-15.326,21.186-8.735,32.601c6.591,11.415,21.186,15.326,32.601,8.735c3.766-2.174,6.709-5.223,8.734-8.738 C163.899,267.2,155.888,262.928,151.472,255.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545456"
    },
    d: "M256,255.279c-4.416-7.649-4.111-16.723,0.002-23.863c-4.057-0.004-8.169,1.02-11.934,3.194 c-11.414,6.59-15.326,21.186-8.735,32.601c9.225,15.978,32.243,15.783,41.335-0.003C268.427,267.2,260.417,262.928,256,255.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545456"
    },
    d: "M360.53,231.416c-18.222-0.019-29.894,19.819-20.67,35.796c6.591,11.415,21.186,15.326,32.601,8.735 c3.766-2.174,6.709-5.223,8.734-8.738C362.821,267.19,351.364,247.329,360.53,231.416z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWait, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wait.5995d7c7.svg";
export { ForwardRef as ReactComponent };